import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadDriver, clearDriver } from '../../common/drivers/actions'
import { Title } from '../components'
import { NewResultForm } from '../forms'

class NewResultPage extends React.Component {
  componentDidMount() {
    const { match, loadDriver, driver } = this.props
    const { params } = match
    if (params.driver && (!driver._id || params.driver !== driver._id)) loadDriver(params.driver)
  }
  componentWillUnmount() {
    this.props.clearDriver()
  }
  render() {
    const { driver } = this.props
    const title = 'Nové hodnocení'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/drivers">Řidiči</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <Link to={`/drivers/${driver._id}`}>{driver.name}</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
        </aside>
        <main className="form-page thin content">
          {!!driver._id && <NewResultForm driver={driver} />}
        </main>
      </div>
    )
  }
}

NewResultPage.propTypes = {
  match: React.PropTypes.object,
  driver: React.PropTypes.object,
  loadDriver: React.PropTypes.func.isRequired,
  clearDriver: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  driver: state.drivers.current,
}), { loadDriver, clearDriver })(NewResultPage)



// WEBPACK FOOTER //
// ./src/browser/pages/NewResult.js